// extracted by mini-css-extract-plugin
export default {"tooltipTrigger":"page-name-tooltip_tooltipTrigger__9WQWT","tooltipContent":"page-name-tooltip_tooltipContent__y6inL"};